import React, { SyntheticEvent, useEffect, useState } from "react";
import * as Icons from "react-feather";
import classNames from "classnames";
import { HealthAndSafetyBadge } from "Components/HealthAndSafetyBadge";
import { ValidationSummary } from "Components/Inputs";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "Components/ReactstrapSlim";
import { BookingMethod, CollectionsClient, CollectionType, IFavoriteWorkspaceViewModel, ResponseWrapper, WorkspaceReservationMethod } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import { FavoriteWidget } from "Components/Favorite/FavoriteWidget";
import { InstantBookBadge } from "Components/InstantBookBadge";
import { Color, FavoriteButton } from "Components/Favorite/FavoriteButton";

export interface WorkspaceProps {
   workspace: IFavoriteWorkspaceViewModel,
   collectionType: CollectionType,
   collectionId: Guid,
   removeWorkspaceCallback: (collectionId: Guid, workspaceId: Guid, workspaceCount: number) => void
}

export const Workspace: React.FC<WorkspaceProps> = ({ workspace, collectionType, collectionId, removeWorkspaceCallback }) => {
   const collectionClient = useApiClient(CollectionsClient);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isDeleted, setIsDeleted] = useState(false);
   const [serverError, setServerError] = useState<Array<[string, string]>>([]);
   const toggleModal = () => {
      setIsModalOpen(!isModalOpen);
      setServerError([["", ""]]);
   }

   const remove = () => {
      collectionClient.deleteWorkspaceFromCollection(collectionId, workspace.id).then(r => {
         removeWorkspaceCallback(collectionId, workspace.id, r);
         toggleModal();
         setIsDeleted(true);
      }).catch((x: ResponseWrapper) => {

         if (x && x.errorMessage) {
            setServerError([["", x.errorMessage]]);
         }
      });
   }
   const heartClick = (e: SyntheticEvent) => {
      e.stopPropagation();
      setIsModalOpen(true);
   }

   useEffect(() => {
      const abortController = new AbortController();

      return function cleanup() {
         abortController.abort();
      }
   }, []);

   return (
      <div key={workspace.id} className={classNames("workspace-wrapper", { "d-none": isDeleted })}>
         <div className="image" onClick={() => window.open(`${workspace.url}`, "_blank")} style={{ cursor: "pointer", backgroundImage: `url(${workspace.image})`, backgroundSize: "cover", backgroundPosition: "center", height: "152px" }}>
            <div className="badges">
               <div className="left">
                  <div className="workspacetile-badges-block">
                     {workspace.hasHealthAndSafetyPolicy && <HealthAndSafetyBadge />}
                     {workspace.bookingMethod == BookingMethod.BookItNow && workspace.reservationMethod != WorkspaceReservationMethod.Period && <InstantBookBadge />}
                  </div>
               </div>
               {collectionType == CollectionType.Regular && <FavoriteButton isFavorited onClick={heartClick} color={Color.white} />}
               {collectionType == CollectionType.Shared && <FavoriteWidget color={Color.white} venueId={workspace.venueId} workspaceId={workspace.id} />}
            </div>
         </div>
         <div className="description container">
            <div className="price-rating">
               <div className="h7">{workspace.priceAmount}{workspace.priceDescription}</div>
               <div className={classNames("p2 rating", { "d-none": workspace.nRatings == 0 })}><Icons.Star size={24} color="#FFC107" fill="#FFC107" /><div className="rating-number">{workspace.averageRating.toFixed(1)}</div></div>
            </div>
            <div className="p2 scenario">{workspace.capacityFilterWithScenario}</div>
            <div className="p2 address">{workspace.address}</div>
         </div>
         <Modal isOpen={isModalOpen} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>Remove Workspace?</ModalHeader>
            <ModalBody className="ls-modal-body">
               Are you sure that you want to remove "{workspace.name}"?
               <ValidationSummary serverErrors={serverError} />
            </ModalBody>
            <ModalFooter>
               <Button color="secondary" onClick={() => toggleModal()}>Cancel</Button>
               <Button color="primary" onClick={() => remove()} aria-label="Remove workspace" >Ok</Button>
            </ModalFooter>
         </Modal>
      </div>
   );
}